import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { StoreFragment } from "@shared/data/fragments";
import { STORE_FRAGMENT } from "@shared/data/fragments";

const STORE_CURRENT_SETUP_PAGE_MUTATION = gql`
  mutation StoreCurrentSetupPage_Shared_Mutation($input: StoreCurrentSetupPageUpdateInput!) {
    storeCurrentSetupPageUpdate(input: $input) {
      store {
        ...StoreFragment
      }
      errors {
        message
      }
    }
  }
  ${STORE_FRAGMENT}
`;

interface StoreCurrentSetupPageData {
  storeCurrentSetupPageUpdate: {
    store: StoreFragment;
  };
}

interface Variables {
  input: {
    attributes?: {
      forProfit?: boolean;
      apiClientId?: string;
      skipToStep?: string;
    };
  };
}

const useStoreCurrentSetupPageMutation = (
  options?: MutationHookOptions<StoreCurrentSetupPageData, Variables>
) => useMutation<StoreCurrentSetupPageData, Variables>(STORE_CURRENT_SETUP_PAGE_MUTATION, options);

export type { StoreCurrentSetupPageData };
export { useStoreCurrentSetupPageMutation, STORE_CURRENT_SETUP_PAGE_MUTATION };
